'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.where = where;
exports['default'] = canonicaliseUrl;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _lodashPickby = require('lodash.pickby');

var _lodashPickby2 = _interopRequireDefault(_lodashPickby);

var _lodashOmitby = require('lodash.omitby');

var _lodashOmitby2 = _interopRequireDefault(_lodashOmitby);

var _lodashIntersection = require('lodash.intersection');

var _lodashIntersection2 = _interopRequireDefault(_lodashIntersection);

var _lodashKeys = require('lodash.keys');

var _lodashKeys2 = _interopRequireDefault(_lodashKeys);

var _lodashMapvalues = require('lodash.mapvalues');

var _lodashMapvalues2 = _interopRequireDefault(_lodashMapvalues);

var _queryString = require('query-string');

var _normaliseSearchQuery = require('./normalise-search-query');

var _normaliseSearchQuery2 = _interopRequireDefault(_normaliseSearchQuery);

var _qualifyUrl = require('./qualify-url');

var _isSearchResultsPath = require('./is-search-results-path');

var _isSearchResultsPath2 = _interopRequireDefault(_isSearchResultsPath);

var _constants = require('./constants');

var pageRegex = /^[1-9]\d*$/;
var removeKeywordsForQueries = ['advertiserid', 'advertisergroup', 'companyid'];
var queryWhitelist = ['keywords', 'page', 'advertiserid', 'advertisergroup', 'companyid'];
var queryPreserveCase = ['advertisergroup'];

/*
 * Turns a search results' location into a 'where' string suppressing the roots.
 * Why? We don't want root locations in our urls.
 */

function where(locale, location) {
  var where = location && location.description ? location.description : '';

  return location === null || locale === 'au' && where === _constants.ALL_AU_WHERE || locale === 'nz' && where === _constants.ALL_NZ_WHERE ? '' : where;
}

var generateCanonicalUrl = function generateCanonicalUrl(_ref) {
  var locale = _ref.locale;
  var path = _ref.path;
  var query = _ref.query;
  var location = _ref.location;

  path = (0, _qualifyUrl.cleanPath)(path);
  query = (0, _normaliseSearchQuery2['default'])({ path: path, query: query });

  query = (0, _lodashOmitby2['default'])(query, function (value, key) {
    switch (key) {
      case 'where':
        return locale === 'au' && value === _constants.ALL_AU_WHERE || locale === 'nz' && value === _constants.ALL_NZ_WHERE;

      case 'page':
        return value === '1' || !pageRegex.test(value);

      case 'keywords':
        return (0, _lodashIntersection2['default'])((0, _lodashKeys2['default'])(query), removeKeywordsForQueries).length > 0;

      default:
        return false;
    }
  });

  // Qualify url, but with a twist: override search location if provided
  if ((0, _isSearchResultsPath2['default'])(path)) {
    var params = (0, _qualifyUrl.unpackJobsUrl)(locale, path, query);

    if (location) {
      params.where = where(locale, location);
    }

    var _packJobsUrl = (0, _qualifyUrl.packJobsUrl)(params);

    path = _packJobsUrl.path;
    query = _packJobsUrl.query;
  }

  query = (0, _lodashPickby2['default'])(query, function (value, key) {
    if (path === '/') {
      return false;
    }

    if (path === '/jobs') {
      return queryWhitelist.indexOf(key) > -1;
    }

    return key === 'page';
  });

  query = (0, _lodashMapvalues2['default'])(query, function (value, key) {
    return queryPreserveCase.indexOf(key) === -1 ? value.toLowerCase() : value;
  });

  return {
    protocol: 'https://',
    host: locale === 'nz' ? 'www.seek.co.nz' : 'www.seek.com.au',
    path: path,
    query: query
  };
};

var generateAlternateUrlFromCanonical = function generateAlternateUrlFromCanonical(_ref2) {
  var locale = _ref2.locale;
  var path = _ref2.path;
  var query = _ref2.query;

  if ((0, _isSearchResultsPath2['default'])(path)) {
    query = (0, _normaliseSearchQuery2['default'])({ locale: locale, path: path, query: query });
    path = '/jobs';
  }

  return {
    protocol: 'http://',
    host: locale === 'nz' ? 'm.seek.co.nz' : 'm.seek.com.au',
    path: path,
    query: query
  };
};

var generateUrlString = function generateUrlString(_ref3) {
  var protocol = _ref3.protocol;
  var host = _ref3.host;
  var path = _ref3.path;
  var query = _ref3.query;

  var queryStr = (0, _queryString.stringify)(query);

  if (queryStr !== '') {
    queryStr = '?' + queryStr;
  }

  return '' + protocol + host + path + queryStr;
};

function canonicaliseUrl(_ref4) {
  var locale = _ref4.locale;
  var path = _ref4.path;
  var query = _ref4.query;
  var location = _ref4.location;

  locale = locale.toLowerCase();
  var canonical = generateCanonicalUrl({ locale: locale, path: path, query: query, location: location });
  var alternate = generateAlternateUrlFromCanonical(_extends({ locale: locale }, canonical));

  return {
    canonical: generateUrlString(canonical),
    alternate: generateUrlString(alternate)
  };
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/@seek/seek-jobs-seo/build/canonicalise-url.js
 ** module id = 550
 ** module chunks = 0
 **/